const styles = theme => ({
    blockContainer:{
        minHeight: "100vh",
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(6),
    },
    mainBlock:{
        textAlign: "center",
        backgroundImage: theme.palette.type === 'dark'
            ? "linear-gradient(145deg, rgba(29, 35, 48, 0.72), rgba(20, 24, 33, 0.68)), url('home-dark.svg')"
            : "linear-gradient(145deg, rgba(255, 255, 255, 0.72), rgba(244, 246, 253, 0.68)), url('home.svg')",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: 'center',
        marginLeft: theme.spacing(6),
        marginRight: theme.spacing(6),
        paddingBottom: theme.spacing(6),
        borderRadius: theme.spacing(3),
        border: `1px solid ${theme.palette.divider}`,
        backdropFilter: 'blur(14px) saturate(135%)',
        boxShadow: 'none',
        [theme.breakpoints.down('sm')]: {
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
        }
    },
    mainTitleText:{
        fontSize: "3.5rem",
        lineHeight: "1",
        fontWeight: "700",
        maxWidth: "37rem",
        marginLeft: "auto",
        marginRight: "auto",
        paddingTop: "3rem"
    },
    mainTitleDescription:{
        maxWidth: "40rem",
        paddingTop: "1.5rem",
        paddingBottom: "1.5rem",
        marginLeft: "auto",
        marginRight: "auto",
        color: theme.palette.text.secondary,
    },
    cardContent: {
        paddingTop: theme.spacing(2),
        paddingBottom: 0,
        textAlign: 'center',
    },
});

export default styles;
